if (typeof ShopifyAPI === "undefined") {
    ShopifyAPI = {};
}

function getCart() {
    var cartContents = fetch(window.Shopify.routes.root + 'cart.js')
        .then(response => response.json())
        .then(data => { return data });
    cartContents;
}

$(document).ready(function () {
    getCart();
})